module.exports = __webpack_public_path__ + "img/palu-bg.c2a640f3.png";